import { ElementRef, Injectable } from "@angular/core";

import _cloneDeep from "lodash/cloneDeep";

@Injectable({
    providedIn: "root"
})
export class ExternalConfigurationService<TConfig> {
    private readonly DEFAULT_DATA_ATTRIBUTE_NAME = "config";

    private _config: TConfig = null;

    public get config(): TConfig {
        return _cloneDeep(this._config) ;
    }

    public initialize(domElement: ElementRef, domAttribute: string = this.DEFAULT_DATA_ATTRIBUTE_NAME): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const json = domElement.nativeElement.dataset[domAttribute];

        if (!json) {
            throw new Error(`Mandatory 'data-${domAttribute}' attribute is not set or empty at the 'ng-app' DOM element.`);
        }

        this._config = JSON.parse(json as string) as TConfig;
    }
}
